module.exports = __webpack_public_path__ + "static/vending_machine-83ef4de4d3a1271b96a856826ccc69d9.png";